import { useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { selectIsAuthenticated, signInWithAuth0 } from "../../store/slices/userSlice";
import { selectLocale } from "../../store/slices/globalConfigSlice";


const SimcaptureContainer = styled.div`
  width:100%;

  iframe{
    width:100%;
  }
`;

const SimcapturePage = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentLocale = useSelector(selectLocale);

  useEffect(() => {
    if (!isAuthenticated) {
      signInWithAuth0(window.location.href, currentLocale);
    }

    var simcaptureUrl = "https://simcapture.helpjuice.com";
    if(currentLocale.startsWith("es")) simcaptureUrl += "/es_MX";
    if(currentLocale.startsWith("ko")) simcaptureUrl += "/ko_KR";

    const helpjuiceUrl = document.createElement('script');
    helpjuiceUrl.innerHTML = `
      var helpjuice_account_url = "${simcaptureUrl}";
    `;

    const helpjuiceScript = document.createElement('script');
    helpjuiceScript.src = "https://s3.amazonaws.com/assets.helpjuice.com/helpjuice.min.js";
    helpjuiceScript.async = true;


    const widgetDiv = document.getElementById('helpjuice_js_widget_content');
    if (widgetDiv) {
      widgetDiv.appendChild(helpjuiceUrl);
      widgetDiv.appendChild(helpjuiceScript);
    }
  }, []);

  const htmlContent = `
    <div id="helpjuice_js_widget_content">
      <img src='https://helpjuice.com/images/cube-theme/loading.gif' class="helpjuice-loading-spinner" />
    </div>
  `;
  return (
    <SimcaptureContainer dangerouslySetInnerHTML={{ __html: htmlContent }} />);
};

export default SimcapturePage;